import PropTypes from 'prop-types';

export const DownArrowIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      className={'custom-icon ' + className}
      style={style}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M5.9911 12.4382C6.52513 11.9347 7.34906 11.9499 7.86782 12.4687L10.3701 14.971L10.3701 5.34328C10.3701 4.59564 10.9652 4.00058 11.7128 4.00059C12.4605 4.00059 13.0555 4.59564 13.0555 5.34328L13.0555 14.971L15.5578 12.4687C16.0766 11.9499 16.9005 11.9499 17.4345 12.4382C17.9838 12.957 17.9991 13.8267 17.465 14.3607L11.7281 20.0977L5.9911 14.3607C5.45708 13.8267 5.47234 12.957 6.02162 12.4382L5.9911 12.4382Z"
        fill="#F22C2C"
      />
    </svg>
  );
};

DownArrowIcon.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
};
